import { BASE_ELEMENT_IDS } from "../BaseDOM";
import { ELEMENT_IDS } from "../mobile/MobileDOM";
import { createElement } from "../../helpers";

export default class AjaxLoading {

    private hided: boolean = true;

    private bg: HTMLElement;
    private reels: HTMLElement[] = [];

    private symbols: any[];

    private hideTimeout: NodeJS.Timeout;

    private baseSpinTime: number = 5000;
    private reelSpinDelay: number = 500;

    private reelCount: number = 4;
    private speed: number = 16;

    private symbolSize: number = 60;
    private symbolGap: number = 10;
    private symbolHeight: number = this.symbolSize + this.symbolGap;


    constructor() {
        const kokotina = require.context(
            "../../../assets/img/inline/ui/icons/loader",
            false,
            /\.svg$/,
            "sync"
        )

        this.symbols = kokotina.keys().map(kokotina);
    }

    create(parent: HTMLElement) {
        parent = document.getElementById(BASE_ELEMENT_IDS.GAME_WRAPPER) || parent;

        let bg = createElement("", ["mx-ajax-loading-bg"], "div");
        this.bg = bg;

        let card = createElement("mxAjaxLoadingCard", ["mx-message-box", 'mx-message-warning'], "div");

        let message = createElement("", ["mx-ajax-loading-message", "mx-translate"], "div",);
        message.setAttribute("data-lang", "waiting_for_server_response");
        this.msgEl = message

        let slotWrapper = createElement("", ["mx-ajax-loading-slot-wrapper"], "div");

        for (let i = 1; i <= this.reelCount; i++) {
            let reel = createElement(`mxAjaxLoadingReel${i}`, ["mx-ajax-loading-reel"], "div");
            reel.style.height = `${(this.symbolHeight * 3)}px`;
            reel.style.width = `${this.symbolSize}px`;
            let symbols = createElement("", ["mx-ajax-loading-symbols"], "div");
            reel.appendChild(symbols);
            this.reels.push(symbols);
            slotWrapper.appendChild(reel);
        }

        card.appendChild(message);
        card.appendChild(slotWrapper);

        bg.appendChild(card);

        for (let i = 0; i < this.reels.length; i++) {
            this.fillReel(this.reels[i]);
            this.reels[i].style.top = (-this.symbolHeight) * (this.reels[i].children.length - 3) + "px";
        }

        parent.appendChild(bg);

        this.hideLoading(0)
    }

    private state: "idle" | "spinning" | "stopping" = "idle"
    private lastTS: number
    private startTS: number

    showLoading() {

        if (!this.hided) return;
        this.hided = false;

        document.getElementById("mxAjaxLoadingContainer")?.classList?.add("loadingio-spinner-spin-pmj0p6bsq8");

        $(this.bg).show();
        $(this.bg).css({ opacity: 1 });

        clearTimeout(this.hideTimeout);

        this.startSpinning()
    }

    private startSpinning(timestamp = 0) {
        if (this.hided) return;
        this.state = "spinning"
        this.lastTS = timestamp
        this.startTS = timestamp

        this.reels.forEach(reel => {
            reel.style.filter = 'blur(2px)'
        })

        for (let i = 0; i < this.reels.length; i++) {
            this.fillReel(this.reels[i]);
            this.reels[i].style.top = (-this.symbolHeight) * (this.reels[i].children.length - 3) + "px";
        }

        requestAnimationFrame((t) => this.spin(t))
    }
    private spin(timestamp: number) {
        if (this.hided) return;
        
        const dT = timestamp - this.lastTS

        this.reels.forEach(el => {
            let offset = parseInt(el.style.top);
            offset += this.symbolHeight * this.speed * (dT / 1000)
            if (offset >= 0) {
                offset = (-this.symbolHeight) * (el.children.length - 3)
            }
            el.style.top = `${offset}px`
        })

        this.lastTS = timestamp

        const spinTime = timestamp - this.startTS
        if (spinTime > this.baseSpinTime) {
            return this.startStopping(timestamp)
        }
        requestAnimationFrame((t) => this.spin(t))
    }

    private startStopping(timestamp = 0) {
        if (this.hided) return;
        this.state = "stopping"
        this.lastTS = timestamp
        this.startTS = timestamp

        requestAnimationFrame((t) => this.stop(t))
    }

    easeInOutCubic(t: number): number {

        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }
    private async stop(timestamp: number) {
        if (this.hided) return;
        const dT = timestamp - this.lastTS
        const ellapsed = timestamp - this.startTS
        this.reels.forEach((el, i) => {
            let offset = parseInt(el.style.top);
            i = i + 1

            if (ellapsed < (this.reelSpinDelay * (i)) - 300) {
                offset += this.symbolHeight * this.speed * (dT / 1000)
                if (offset >= 0) {
                    offset = (-this.symbolHeight) * (el.children.length - 3)
                }
                el.style.top = `${offset}px`
                return
            }

            if (this.reelSpinDelay * i - ellapsed > 0 && this.reelSpinDelay * i - ellapsed < 300) {
                offset += Math.min(
                    Math.abs(offset % this.symbolHeight),
                    this.symbolHeight * this.speed
                ) * this.easeInOutCubic((this.reelSpinDelay * i - ellapsed) / 300) * (dT / 1000)
                el.style.top = `${offset}px`
                return
            }
            if (offset % this.symbolHeight !== 0) {
                offset += Math.abs(offset % this.symbolHeight)
                el.style.top = `${offset}px`
                return
            }
            el.style.filter = ""
        })
        this.lastTS = timestamp
        if (ellapsed > (this.reels.length + 1) * this.reelSpinDelay) {
            this.state = "idle"
            setTimeout(() => this.startSpinning(timestamp), 1500)
            return
        }
        requestAnimationFrame(t => this.stop(t))
    }

    private fillReel(reel: HTMLElement) {
        reel.innerHTML = "";
        for (let i = 0; i < 37; i++) {
            const s = document.createElement("img");
            s.className = "mx-ajax-loading-symbol";
            const random = Math.floor(Math.random() * this.symbols.length)
            s.src = Math.random() > 0.3 ? this.symbols[random] : this.symbols[0];
            s.style.marginTop = `${this.symbolGap}px`
            s.style.width = `${this.symbolSize}px`
            s.style.height = `${this.symbolSize}px`
            reel.appendChild(s);
        }
    }

    hideLoading(duration = 310) {

        if (this.hided) return;
        this.hided = true;

        clearTimeout(this.hideTimeout);

        $(this.bg).css({opacity: 0});

        this.hideTimeout = setTimeout(() => {
            $(this.bg).hide();
        }, duration);

    }

    destroy() {
        if (document.getElementById(BASE_ELEMENT_IDS.AJAX_LOADING_CONTAINER))
            this.bg.removeChild(document.getElementById(BASE_ELEMENT_IDS.AJAX_LOADING_CONTAINER));
    }
}
